import { useModelService } from 'services/model/model.service';
import { customKpi, measureKpi, InfoDrawerKpiEntry } from 'components/InfoDrawer/InfoDrawerKpiEntry';
import { InfoDrawerKpis } from 'components/InfoDrawer/InfoDrawerKpis';
import { InfoContentItem } from 'components/InfoDrawer/InfoContentItem';

function useGmvCategoryBreakdownKpis(): InfoDrawerKpiEntry[] {
  const { getMeasures } = useModelService();

  const [ordGmvVal, itemNetSlsGmvVal, retQtyRate, netSlsGmvVal, ordQty] = getMeasures([
    'ordGmvVal',
    'itemNetSlsGmvValExpOD',
    'retQtyRateExpOD',
    'netSlsGmvValExpOD',
    'ordQty',
  ]);

  return [
    customKpi('share_per_channel', {
      titleId: 'insights.marketplace_tab.marketplace_channel_breakdown.report.share_per_channel',
      descriptionId: 'insights.marketplace_tab.marketplace_channel_breakdown.report.share_per_channel_description',
    }),
    measureKpi(ordGmvVal),
    measureKpi(ordQty),
    measureKpi(itemNetSlsGmvVal),
    measureKpi(retQtyRate),
    measureKpi(netSlsGmvVal),
  ];
}

export function GmvCategoryBreakdownInfoContent() {
  const kpis = useGmvCategoryBreakdownKpis();

  return (
    <InfoDrawerKpis.Default
      kpis={kpis}
      whyUsefulTitleId="info.content.why_is_it_useful"
      whyUsefulDescriptionId="insights.report.category_channel_breakdown.why_is_it_useful"
      showOrderBasedNote
    >
      <hr className="my-4 border-snow-200" />
      <InfoContentItem
        titleId="info.content.data_availability"
        descriptionId="info.content.data_availability.description"
      />
    </InfoDrawerKpis.Default>
  );
}
